<template><fleet-list kind="product" v-bind="$props"></fleet-list></template>
<script>
import FleetList from '../FleetList/index.vue'
import props from '../FleetList/props'
export default { name: 'avue-echart-productList', mixins: [props], components: { FleetList } }
</script>
